import { Button, Divider, Modal, Radio } from "antd";
import { useState } from "react";
import { staffActions } from "../../service/api";

const ParentActionModal = ({ actionData, open, onClose }) => {
  const [value, setValue] = useState("DROP_OFF_KID");
  const [isLoading, setIsLoading] = useState(false)

  const { attendanceActions, userId, userType } = actionData || {}

    const formattedData = attendanceActions?.map((item) => ({
        value: item,
        label: item
            .toLowerCase()
            .split("_")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
    }));

  console.log("attendanceActions",attendanceActions)
  const handleStaffAction = async () => {
    const body = {
      userId,
      userType,
      action: value
    }
    setIsLoading(true)
    try {
      const res = await staffActions(body)
      if (res?.status === 201) {
        console.log(res)
        onClose()
        setIsLoading(false)
      }
    } catch (error) {
      console.log(error)
      setIsLoading(false)

    }
  }
  return (
    <Modal
      open={open}
      footer={null}
      onCancel={onClose}
      title="Select Option"
      centered
      width={400}
    >

      <Radio.Group
        onChange={(e) => setValue(e.target.value)}
        value={value}
        style={{ display: "flex", flexDirection: "column", gap: 10 }}
      >
        {formattedData?.map((item, index) => (
          <Radio value={item.value} key={index}>
            {item.label}
          </Radio>
        ))}
       
      </Radio.Group>
      <Divider />
      <Button
        type="primary"
        block
        loading={isLoading}
        style={{ marginTop: 20 }}
        onClick={handleStaffAction}
      >
        Submit
      </Button>
    </Modal>
  );
};

export default ParentActionModal;
